import { PayloadAction } from '@reduxjs/toolkit';
import { takeLatest } from 'redux-saga/effects';
import { successLogin } from '../reducers/auth';

// Watch 함수
function* watchLogin(action: PayloadAction<any>) {}

export default function* authSaga() {
  yield takeLatest(successLogin.type, watchLogin);
}
